import MaterialThumb from './MaterialThumb';
import { Box, Typography } from '@mui/material';
import { MaterialNames } from 'Constants';
import { Material } from 'Types';

function MaterialLabelWithThumb(props: { material: Material }) {
  const { material } = props;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }} key={material}>
      <Box sx={{ mr: 1 }}>
        <MaterialThumb material={material} />
      </Box>
      <Typography>
        ({material}) {MaterialNames[material]}
      </Typography>
    </Box>
  );
}

export default MaterialLabelWithThumb;
